import { render, staticRenderFns } from "./popup_enabled_programme.vue?vue&type=template&id=203bad50&"
import script from "./popup_enabled_programme.vue?vue&type=script&lang=js&"
export * from "./popup_enabled_programme.vue?vue&type=script&lang=js&"
import style0 from "./popup_enabled_programme.vue?vue&type=style&index=0&id=203bad50&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PopupModal: require('/home/runner/work/mywellness-fiesta-2026/mywellness-fiesta-2026/user/components/popup_modal.vue').default})
